import React from "react";
import { Link } from "react-router-dom";
import { Lock, Check, ArrowRight } from "lucide-react";
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const BULLETS = [
    "Unlimited practice sessions",
    "Multi-session client engagements (up to 8)",
    "Full supervisor reviews & rubric",
    "Complete Learn library (31 chapters, 6 methods)",
];

/**
 * Paywall modal — shown when POST /sessions returns 402 with the
 * `subscription_required` detail. Doesn't navigate away; user can subscribe
 * then return to the same setup state.
 */
export const PaywallDialog = ({ open, onOpenChange, freeUsed = 2, freeQuota = 2, priceInr = 2999 }) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-md" data-testid="paywall-dialog">
            <DialogHeader>
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-amber-100 text-amber-700">
                    <Lock className="h-5 w-5" />
                </div>
                <DialogTitle className="text-xl font-semibold tracking-tight" data-testid="paywall-title">
                    You&apos;ve used your {freeQuota} free sessions
                </DialogTitle>
                <DialogDescription className="text-sm text-muted-foreground">
                    Subscribe to keep practising without limits.
                </DialogDescription>
            </DialogHeader>

            <ul className="space-y-2 py-2">
                {BULLETS.map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-foreground">
                        <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-emerald-100 text-emerald-700">
                            <Check className="h-3 w-3" strokeWidth={3} />
                        </span>
                        {b}
                    </li>
                ))}
            </ul>

            <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-between">
                <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="paywall-dismiss">
                    Maybe later
                </Button>
                <Button asChild className="bg-primary hover:bg-primary-hover font-semibold" data-testid="paywall-subscribe-button">
                    <Link to="/subscribe">
                        Subscribe — ₹{priceInr.toLocaleString()}/year
                        <ArrowRight className="h-4 w-4" />
                    </Link>
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);
